<rt-box layout-vertical [class.invalid]="generalContextControl.invalid">
  <div margin-bottom>
    <div layout layout-align-items-center>
      <rt-heading variant="heading large block">
        {{ 'app.requisitions.details_page.context.heading' | translate }}
      </rt-heading>
      @if (!generalContextControl.value && isFormEditable) {
        <span class="asterisk">*</span>
      }
      <rt-requisition-only-icon margin-left-small-x></rt-requisition-only-icon>
    </div>

    <rt-heading variant="subheading normal">
      {{ 'app.requisitions.details_page.context.subheading' | translate }}
    </rt-heading>
  </div>
  <rt-form-field>
    @if (isFormEditable) {
      <rt-wysiwyg
        prosemirrorDefaultConfig
        [config]="ProsemirrorConfig"
        [formControl]="generalContextControl"
        [placeholder]="'app.requisitions.details_page.context.placeholder' | translate"
        [withMinHeight]="true"
      ></rt-wysiwyg>
    } @else {
      <div
        prosemirrorDefaultConfig
        [prosemirrorRender]="generalContextControl.value"
        [prosemirrorRenderConfig]="ProsemirrorConfig"
        class="read-only"
      ></div>
    }
  </rt-form-field>
</rt-box>
